module.exports = __webpack_public_path__ + "images/sam/ajax-loader.gif";